function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Image } from "expo-image";
import { useEffect } from "react";
import { ContentType } from "@oui/lib/src/types";
import FacialRecognition from "../assets/facialRecognition.svg";
import { AuthScreenContainer } from "../components/AuthScreenContainer";
import { Button } from "../components/Button";
import { Fingerprint } from "../components/Fingerprint";
import { Text } from "../components/Text";
import { View } from "../components/View";
import { useProgressComplete } from "../hooks/useCurrentUser";
import { usePersistedState } from "../hooks/usePersistedState";
import { AuthenticationTypes, useReauthenticationState } from "../hooks/useReauthenticationState";
import { useI18n } from "../lib/i18n";
import { useTheme } from "../styles";
function getMethodName($t, type) {
    switch(type){
        case AuthenticationTypes.FINGERPRINT:
            return $t({
                id: 'LocalAuthenticationPrompt_fingerprintMethod',
                defaultMessage: 'Fingerprint'
            });
        case AuthenticationTypes.FACIAL_RECOGNITION:
            return $t({
                id: 'LocalAuthenticationPrompt_faceMethod',
                defaultMessage: 'FaceID'
            });
        case AuthenticationTypes.IRIS:
            return $t({
                id: 'LocalAuthenticationPrompt_irisMethod',
                defaultMessage: 'Iris unlock'
            });
    }
}
/**
 * Allows user to resume an existing user session using a previously configured
 * device authentication mechanism. Supports a device enabled biometric sensor.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-148}
 */ export function LocalAuthenticationPrompt(props) {
    var _usePersistedState = _sliced_to_array(usePersistedState('SeenLocalAuthenticationPrompt', false), 2), setHasSeenLocalAuthenticationPrompt = _usePersistedState[1];
    var _useProgressComplete = useProgressComplete(ContentType.MYPLAN, false), myStoryMyPlanNotComplete = _useProgressComplete.completeResult;
    var $t = useI18n().$t;
    var _useReauthenticationState = useReauthenticationState(), isLoading = _useReauthenticationState.isLoading, supportedTypes = _useReauthenticationState.supportedTypes, enroll = _useReauthenticationState.enroll;
    var theme = useTheme().theme;
    var onDone = function() {
        if (myStoryMyPlanNotComplete) {
            props.navigation.navigate('FinishPatientRegistration');
            setHasSeenLocalAuthenticationPrompt(true);
            return;
        }
        setHasSeenLocalAuthenticationPrompt(true);
    };
    var supportedType = supportedTypes[supportedTypes.length - 1];
    var method = getMethodName($t, supportedType);
    var _usePersistedState1 = _sliced_to_array(usePersistedState('disableLocalAuthentication', false), 3), disableLocalAuthentication = _usePersistedState1[0], loadingDisableLocalAuthentication = _usePersistedState1[2];
    useEffect(function() {
        if (!loadingDisableLocalAuthentication && disableLocalAuthentication) {
            onDone();
        }
    // we want this effect to run once when disableLocalAuthentication has loaded. At that time,
    // the closure will update to the latest values of onDone/disableLocalAuthentication
    // eslint-disable-next-line
    }, [
        loadingDisableLocalAuthentication
    ]);
    useEffect(function() {
        if (!isLoading && supportedTypes.length === 0) {
            onDone();
        }
    // closure will have latest onDone when running
    // eslint-disable-next-line
    }, [
        isLoading,
        supportedTypes
    ]);
    return isLoading ? /*#__PURE__*/ _jsx(AuthScreenContainer, {
        heading: "",
        children: /*#__PURE__*/ _jsx(View, {})
    }) : /*#__PURE__*/ _jsx(AuthScreenContainer, {
        heading: $t({
            id: 'LocalAuthenticationPrompt_heading',
            defaultMessage: 'Enable {method}?'
        }, {
            method: method
        }),
        children: /*#__PURE__*/ _jsxs(View, {
            spacing: 16,
            style: {
                alignItems: 'center'
            },
            children: [
                supportedType === AuthenticationTypes.FINGERPRINT ? /*#__PURE__*/ _jsx(Fingerprint, {
                    color: theme.color.accentTwo100
                }) : null,
                supportedType === AuthenticationTypes.FACIAL_RECOGNITION ? /*#__PURE__*/ _jsx(Image, {
                    source: FacialRecognition,
                    style: {
                        width: 62,
                        height: 62
                    }
                }) : null,
                /*#__PURE__*/ _jsx(Text, {
                    testID: "LocalAuthenticationPrompt_".concat(supportedType),
                    text: $t({
                        id: 'LocalAuthenticationPrompt_description',
                        defaultMessage: 'Use {method} to log in securely and easily. You can enable or disable it in your account settings at any time.'
                    }, {
                        method: method
                    }),
                    weight: "semibold",
                    size: 16,
                    style: {
                        marginBottom: 20,
                        textAlign: 'center'
                    }
                }),
                /*#__PURE__*/ _jsx(Button, {
                    onPress: /*#__PURE__*/ _async_to_generator(function() {
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        enroll()
                                    ];
                                case 1:
                                    _state.sent();
                                    onDone();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    alignSelf: "center",
                    text: $t({
                        id: 'LocalAuthenticationPrompt_acceptButton',
                        defaultMessage: 'Yes, enable'
                    }),
                    testID: "LocalAuthenticationPrompt_acceptButton"
                }),
                /*#__PURE__*/ _jsx(Button, {
                    onPress: onDone,
                    alignSelf: "center",
                    variant: "text",
                    text: $t({
                        id: 'LocalAuthenticationPrompt_denyButton',
                        defaultMessage: 'Not now'
                    }),
                    testID: "LocalAuthenticationPrompt_denyButton"
                })
            ]
        })
    });
}
